import { IValidator, Validations } from '@samc/centricity-core';
import { isNullOrEmpty } from '@/utils';
import { IReviewTypeStepInput } from '@/Interfaces';

export class ReviewTypeStepInputValidator implements IValidator<IReviewTypeStepInput> {
  public isValid(value: IReviewTypeStepInput): Validations<IReviewTypeStepInput> {
    const validations: Validations<IReviewTypeStepInput> = {};

    if (isNullOrEmpty(value.reviewTypeId)) validations.reviewTypeId = 'Review Type Is Required';
    return validations;
  }
}